import * as z from "zod";
import { mutator } from "./mutator";

export const revokeScimTokenSchema = z.object({
  ssoProviderId: z.string(),
});

export const revokeScimToken = mutator({
  schema: revokeScimTokenSchema,
  resolve: {
    provider: { kind: "ssoProvider", from: "ssoProviderId" },
  },
  permissions: [
    { permission: "tenant:sso_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, args: { provider } }) => {
    await tx.mutate.ssoProvider.update({
      id: provider.id,
      syncMode: "off",
      jitUserProvisioning: false,
      scimTokenExpiresAt: null,
      updatedAt: Date.now(),
    });
  },
});
